"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sharedPropTypes = exports.describedArrowPositionPropType = exports.arrowPositionPropType = exports.describedPopoverAlignmentPropType = exports.popoverAlignmentPropType = exports.describedPopoverPositionPropType = exports.popoverPositionPropType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _propTypes2 = require("../prop-types");

var _constants = require("./constants");

var popoverPositionPropType = _propTypes.default.oneOf(Object.values(_constants.POPOVER_POSITION));

exports.popoverPositionPropType = popoverPositionPropType;

var describedPopoverPositionPropType = _stencilReactDesc.PropTypes.oneOf(Object.values(_constants.POPOVER_POSITION));

exports.describedPopoverPositionPropType = describedPopoverPositionPropType;

var popoverAlignmentPropType = _propTypes.default.oneOf(Object.values(_constants.POPOVER_ALIGNMENT));

exports.popoverAlignmentPropType = popoverAlignmentPropType;

var describedPopoverAlignmentPropType = _stencilReactDesc.PropTypes.oneOf(Object.values(_constants.POPOVER_ALIGNMENT));

exports.describedPopoverAlignmentPropType = describedPopoverAlignmentPropType;

var arrowPositionPropType = _propTypes.default.oneOf(Object.values(_constants.ARROW_POSITION));

exports.arrowPositionPropType = arrowPositionPropType;

var describedArrowPositionPropType = _stencilReactDesc.PropTypes.oneOf(Object.values(_constants.ARROW_POSITION));

exports.describedArrowPositionPropType = describedArrowPositionPropType;
var sharedPropTypes = {
  children: _stencilReactDesc.PropTypes.func.isRequired.description('Render function which renders the trigger for the popover.').format("({\n  isOpen: boolean,\n  open: function,\n  close: function,\n  toggle: function\n}) => node"),
  popoverPosition: describedPopoverPositionPropType.description('Vertical position for the popover relative to the trigger.'),
  popoverAlignment: describedPopoverAlignmentPropType.description('Horizontal position for the popover relative to the trigger.'),
  shouldAutoReposition: _stencilReactDesc.PropTypes.bool.description('Determines whether the component should automatically recalulate popoverPosition and popoverAlignment based on available space.').defaultValue(true),
  popoverWidth: (0, _propTypes2.cssValue)().description("Sets the CSS 'width' property for the popover container."),
  popoverMaxWidth: (0, _propTypes2.cssValue)().description("Sets the CSS 'max-width' property for the popover container."),
  renderPopoverContent: _stencilReactDesc.PropTypes.func.isRequired.description('Render function which renders the content shown in the popover.').format("({\n  close: function\n}) => node"),
  shouldCloseOnFocusLeave: _stencilReactDesc.PropTypes.bool.description('Whether the popover should close when it loses focus.'),
  padding: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'padding' property for the popover container."),
  buttonPopover: _stencilReactDesc.PropTypes.bool.description('Adjusts the style of the popover when the trigger is a button.'),
  'aria-haspopup': _stencilReactDesc.PropTypes.string.description("Sets 'aria-haspopup' property on the trigger and corresponding role on the popover content.")
};
exports.sharedPropTypes = sharedPropTypes;